var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wecoupon-mall-loading"},_vm._l((_vm.dotList),function(item,i){return _c('div',{key:i,staticClass:"dot"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }